// noinspection JSUnusedGlobalSymbols

import {configureStore} from '@reduxjs/toolkit';
import {persistStore, persistReducer, createTransform, type Transform} from 'redux-persist';
import {encryptTransform as _encryptTransform} from 'redux-persist-transform-encrypt';
import {reduxStorage} from './storage';

import {rootReducer} from './reducers/root.reducer';

const encryptTransform = _encryptTransform as unknown as (
  config: any
) => Transform<any, any>;

const secretKey = 'shared-key';

const persistConfig = {
  key: 'root',
  version: 2,
  storage: reduxStorage,
  serialize: true,
  deserialize: true,
  whitelist: ['App', 'Db', 'Data', 'Device', 'User'],
  transforms: [
    encryptTransform({
      secretKey,
      onError: (err: Error) => console.error('Encryption error:', err),
    }),
    createTransform(
      (inboundState) => inboundState,
      (outboundState) => {
        return outboundState;
      }
    )
  ],
  migrate: (state: any): Promise<any> => {
    if (!state) return Promise.resolve({});
    return Promise.resolve({
      ...state,
      App: {
        ...state.App
      },
      Db: {
        ...state.Db
      },
      Data: {
        ...state.Data
      },
      Device: {
        ...state.Device
      },
      User: {
        ...state.User
      }
    });
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer as any);

export const store: any = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER',
          'persist/FLUSH',
        ],
      }
    })
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
